import { render, staticRenderFns } from "./BranchCrud.vue?vue&type=template&id=4b8996f0"
import script from "./BranchCrud.vue?vue&type=script&lang=js"
export * from "./BranchCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports